export const sharedErrorStringsEN = {
  title: {
    default: 'Error',
    gqlErrors: 'There was a problem with your request',
  },
  message: {
    default: "Whoops! Our wires got crossed, but we're working on it now.",
  },
  buttons: {
    retry: 'Retry',
    cancel: 'Cancel',
    done: 'Done',
    tryAgain: 'Try again',
    logOut: 'Log out',
    waitCountdown: 'Wait {{seconds}}s',
  },
  pageDown: {
    title: 'We’re fixing a technical issue',
    message: 'Thanks for your patience while we get things back up.',
  },
  errorCopy: {
    network: {
      title: 'Connection issue',
      message: 'Please check your internet connection and try again.',
    },
    server: {
      title: 'We’re fixing a technical issue',
      message: 'Our servers are having a moment. Please try again later.',
    },
    client: {
      title: 'There was a problem with your request',
      message: 'Please review your request and try again.',
    },
    timeout: {
      title: 'Request timed out',
      message: 'The request took too long to complete. Please try again.',
    },
    graphql: {
      title: 'There was a problem with your request',
      message: "Whoops! Our wires got crossed, but we're working on it now.",
    },
  },
};
